import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Div from '@hellodarwin/core/lib/components/common/div';
import Link from 'antd/es/typography/Link';
import { useMemo } from 'react';
import { useTheme } from 'styled-components';
import { useComponent } from '../../../hooks/useComponent';
import Container from '../../common/Container';
import CTAsList from '../../common/CTAsList';
import ItemsHeader from '../Steps/StepsHeader';
import ContactMethodsLayout from './ContactMethodsLayout';
import DefaultTile from './DefaultTile';
import ProgramTile from './ProgramTile';
import ShowcaseTile from './ShowcaseTile';
import { ItemsListStyled } from './styles';
import UnknownTile from './UnknownTile';
const ItemsList = ({ componentType, entryId, nested }) => {
    var _a;
    const theme = useTheme();
    const itemsList = useComponent(entryId, componentType);
    const { CTAs, items, backgroundColor, body, bodyLong, direction, cardStyle, isWide, title, } = (_a = itemsList === null || itemsList === void 0 ? void 0 : itemsList.fields) !== null && _a !== void 0 ? _a : {};
    const isNestedHdAddress = nested && cardStyle === 'hd-address';
    const withBackground = useMemo(() => !!backgroundColor &&
        backgroundColor !== 'transparent' &&
        backgroundColor !== 'beige_2', [backgroundColor]);
    const containerProps = useMemo(() => {
        const isShowcase = items === null || items === void 0 ? void 0 : items.some((item) => item.sys.contentType.sys.id === 'ContentfulShowCaseCardComponent');
        const containerBackgroundColor = withBackground
            ? backgroundColor === 'gradient'
                ? 'gradient'
                : theme.colors[backgroundColor]
            : undefined;
        return {
            containerBackgroundColor,
            overflowHidden: true,
            alignement: isNestedHdAddress ? 'start' : undefined,
            cap: isShowcase ? 560 * 3 : isWide ? theme.caps.big : undefined,
            noPadding: isNestedHdAddress,
            removeContainer: isNestedHdAddress,
            styles: isNestedHdAddress
                ? {
                    content: {
                        justifyContent: 'flex-start',
                    },
                }
                : undefined,
        };
    }, [
        backgroundColor,
        isNestedHdAddress,
        isWide,
        items,
        theme.caps.big,
        theme.colors,
        withBackground,
    ]);
    if (cardStyle === 'hd-address') {
        return (_jsx(Container, Object.assign({}, containerProps, { children: _jsx(ContactMethodsLayout, { body: body, bodyLong: bodyLong, CTAs: CTAs, items: items, title: title }) })));
    }
    return (_jsx(Container, Object.assign({}, containerProps, { children: _jsxs(Div, { flex: "column", gap: theme.spacing.xl, align: "center", style: { position: 'relative', zIndex: 2, width: '100%' }, children: [_jsx(ItemsHeader, Object.assign({}, itemsList === null || itemsList === void 0 ? void 0 : itemsList.fields, { direction: "column", titleLevel: 2, CTAs: undefined })), _jsxs(Div, { flex: "column", gap: 48, align: "center", children: [_jsx(Div, { flex: "column", gap: 32, align: "center", style: cardStyle === 'Showcase'
                                ? { paddingLeft: '100px', paddingRight: '100px' }
                                : undefined, children: _jsx(ItemsListStyled, { "$direction": direction, "$cardStyle": cardStyle, "$size": items === null || items === void 0 ? void 0 : items.length, children: items === null || items === void 0 ? void 0 : items.map((itm) => {
                                    switch (itm.sys.contentType.sys.id) {
                                        case 'showCaseCard':
                                            return (_createElement(ShowcaseTile, Object.assign({}, itm.fields, { key: itm.sys.id })));
                                        case 'simpleColumnComponent':
                                            switch (cardStyle) {
                                                case 'program':
                                                    return (_jsx(ProgramTile, { entryId: itm.sys.id, componentType: 'simpleColumnComponent', isWide: isWide, direction: direction }, itm.sys.id));
                                                default:
                                                    return (_jsx(DefaultTile, { entryId: itm.sys.id, componentType: 'simpleColumnComponent', isWide: isWide, direction: direction }, itm.sys.id));
                                            }
                                        case 'linkComponent':
                                            return (_createElement(Link, Object.assign({}, itm, { key: itm.sys.id })));
                                        default:
                                            return (_jsx(UnknownTile, { type: itm.sys.contentType.sys.id, component: itm }, itm.sys.id));
                                    }
                                }) }) }), (CTAs === null || CTAs === void 0 ? void 0 : CTAs.length) > 0 && (_jsx(CTAsList, { CTAs: CTAs === null || CTAs === void 0 ? void 0 : CTAs.map((cta) => cta.fields) }))] })] }) })));
};
export default ItemsList;
